module.exports = __webpack_public_path__ + "img/uk-female.c9460737.png";